import React from "react";
import Hero from "../components/Hero";
import LogoMarquee from "../components/LogoMarquee";
import Services from "../components/Services";
import Approach from "../components/Approach";
import Security from "../components/Security";
import Testimonials from "../components/Testimonials";
import CTABand from "../components/CTABand";

const Home = () => {
  return (
    <div>
      <Hero />
      <LogoMarquee />
      <Services />
      <Approach />
      <Security />
      <Testimonials />
      <CTABand />
    </div>
  );
};

export default Home;
